import React, { FC } from 'react';
import { Loader, Slider } from '$shared/components';
import { RecommendationsSliderItem } from '$core/Feed/RecommendationsSliderItem/RecommendationsSliderItem';
import { useTranslator } from '$hooks';
import { FollowRecommendationsProps } from '$core/Profile/FollowRecommendations/FollowRecommendations.interface';

export const FollowRecommendations: FC<FollowRecommendationsProps> = ({ authorIds }) => {
  const t = useTranslator();

  return authorIds.length ? (
    <div className="FollowRecommendations">
      <Slider
        headerText={t('profile_recommended_models_header')}
        className="RecommendationsSlider"
      >
        {authorIds.map((item) => (
          <RecommendationsSliderItem userId={item} key={item} />
        ))}
      </Slider>
    </div>
  ) : null;
};
